import { useEffect, useState } from 'react';

/**
 * Renvoie `true` si l'utilisateur a activé la préférence système
 * "prefers-reduced-motion: reduce".
 *
 * Permet de sauter les animations dans CountUp, Reveal, StaggerGrid,
 * PageTransition, etc. en affichant directement l'état final.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handler = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return reduced;
}
